import theme from "../gatsby-theme-blog/gatsby-plugin-theme-ui";
export default theme;
